import React, { useState } from "react";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";
import dummyProfileImage from "../../../assets/dummy-profile-pic.png";
import { sendPriorityDm } from "../../../ApiServices/ApiServices";
import {handleError, handleSuccess} from '../../../Utils'

const Message = ({ setIsPriorityDMVisible, mentorName, profileImage, id }) => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSendMessage = async () => {
    if (message.trim() === "") {
      setError("Please enter a detailed question before sending.");
      return;
    }
    try {
      const data = {};
      data.id = id;
      data.message = message;
      const res = await sendPriorityDm(data);
      handleSuccess(res?.message)
      setError("");
      setIsPriorityDMVisible(false);
    } catch (error) {
        return handleError(error?.response?.data?.message)
    }
    setError("");
  };
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-96 sm:w-11/12 md:w-1/2 lg:w-96 relative"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <span
          className="absolute right-0 top-0 cursor-pointer"
          onClick={() => setIsPriorityDMVisible(false)}
        >
          <CloseIcon />
        </span>
        {/* Mentor Info */}
        <div className="flex items-center mb-4">
          <img
            className="w-8 h-8 rounded-full mr-3"
            src={profileImage || dummyProfileImage}
            alt="mentor"
          />
          <div className="text-lg font-semibold">{mentorName}</div>
          <div className="ml-auto bg-gray-200 text-gray-600 rounded-full px-3 py-1 text-sm flex items-center justify-center">
            <span>
              <StarIcon className="text-gray-500 mr-1" />
            </span>{" "}
            5/5
          </div>
        </div>

        <div className=" mb-4">
          <div className="text-xl font-bold text-black">Priority DM</div>
          <div className="text-[10px]">Please expect reply in 2 days</div>
        </div>

        <label className="block text-sm mt-2">Your question</label>

        <textarea
          className="w-full mt-2 p-3 border border-gray-300 rounded-md resize-none"
          rows="4"
          placeholder="Try asking a detailed question..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>

        {/* Error Message */}
        {error && <div className="text-red-500 text-sm mt-2">{error}</div>}

        <button
          onClick={handleSendMessage}
          className="w-full mt-4 py-2 px-4 bg-black text-white font-bold rounded-md hover:bg-gray-800 transition-all"
        >
          Send Message
        </button>
      </div>
    </div>
  );
};

export default Message;
